export default "__VITE_ASSET__C4ZG3XOB__"